import { render, staticRenderFns } from "./saveMoreOffers.vue?vue&type=template&id=f363526a&scoped=true&"
import script from "./saveMoreOffers.vue?vue&type=script&lang=js&"
export * from "./saveMoreOffers.vue?vue&type=script&lang=js&"
import style0 from "./saveMoreOffers.vue?vue&type=style&index=0&id=f363526a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f363526a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
